import { useDrag as useLibraryDrag, useDrop as useLibraryDrop } from 'react-dnd';
import { useRef } from 'react';

export default function useDrag(
  id: string,
  index: number,
  maxRange: number,
  onItemMove: (startIndex: number, endIndex: number) => void,
  onItemDrop: () => void,
) {
  const elementRef = useRef(null);

  const [{ isDragging }, dragHandleRef, connectPreview] = useLibraryDrag({
    type: 'SIMPLE_COMPONENT',
    item: { id, index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const [, connectDrop] = useLibraryDrop({
    accept: 'SIMPLE_COMPONENT',
    hover(item: { id: string; index: number }) {
      const startIndex = item.index;

      const hoverIndex = index;

      // Don't replace items with themselves or if the hover index is greater than the max range
      if (startIndex === hoverIndex || hoverIndex > maxRange) {
        return;
      }

      const offset = hoverIndex - startIndex;

      const newIndex = startIndex + offset;
      onItemMove(startIndex, newIndex);
      item.index = hoverIndex;
    },
    drop() {
      onItemDrop();
    },
  });

  connectPreview(elementRef);
  connectDrop(elementRef);

  return { elementRef, dragHandleRef, isDragging };
}
